
const BrandIP = () => {
  const characteristics = [
    {
      icon: 'ri-mountain-line',
      title: '坚韧不拔',
      description: '如马帮在崎岖山路上的坚持，面对任何困难都不轻言放弃'
    },
    {
      icon: 'ri-handshake-line',
      title: '诚信守义',
      description: '马帮人一诺千金的品格，诚信经营是我们永恒的准则'
    },
    {
      icon: 'ri-sun-line',
      title: '乐观向上',
      description: '即使在最艰难的岁月，也保持着对美好生活的向往'
    },
    {
      icon: 'ri-lightbulb-line',
      title: '智慧传承',
      description: '三百年制茶智慧的结晶，传统与现代的完美融合'
    }
  ];

  return (
    <section className="py-12 lg:py-16 bg-primary">
      <div className="px-6 lg:px-16">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
            {/* 马帮哥形象 */}
            <div className="text-center lg:text-left">
              <div className="relative">
                <img 
                  src="https://static.readdy.ai/image/2e1ac11483faca2c19cd44d7d582b015/0825bb3c70043ca43296b37b7045ea0b.jpeg"
                  alt="马帮哥"
                  className="w-full max-w-sm mx-auto lg:mx-0 rounded-xl shadow-2xl"
                />
                <div className="absolute -bottom-3 -right-3 bg-accent rounded-lg p-3 shadow-lg">
                  <i className="ri-cup-line text-xl text-primary"></i>
                </div>
              </div>
            </div>

            {/* 马帮哥介绍 */}
            <div>
              {/* 基本介绍 */}
              <div className="mb-6">
                <h2 className="text-2xl lg:text-3xl font-bold text-white font-serif mb-3">品牌传承人·玥姐</h2>
                <p className="text-base text-accent font-medium mb-3">马帮后代 · 首席制茶师</p>
                <p className="text-gray-300 leading-relaxed text-base">
                  张玥是马帮瑞贡品牌的灵魂人物，她是马帮第九代传承人，长期聚焦云南茶马古道历史脉络、贡茶制度演变及传统工艺传承等领域，主持或参与多项省级、市级茶文化研究课题。
                </p>
              </div>

              {/* 职务信息 */}
              <div className="grid grid-cols-1 gap-3 mb-6">
                <div className="bg-white/10 rounded-lg p-4 shadow-sm hover:shadow-lg transition-all duration-300">
                  <div className="flex items-center space-x-3">
                    <div className="w-10 h-10 bg-accent/20 rounded-full flex items-center justify-center flex-shrink-0">
                      <i className="ri-award-line text-lg text-accent"></i>
                    </div>
                    <div>
                      <h3 className="text-sm font-bold text-white font-serif">云南省茶马古道研究会贡茶专家委员会</h3>
                      <p className="text-xs text-accent font-medium">主任</p>
                    </div>
                  </div>
                </div>

                <div className="bg-white/10 rounded-lg p-4 shadow-sm hover:shadow-lg transition-all duration-300">
                  <div className="flex items-center space-x-3">
                    <div className="w-10 h-10 bg-accent/20 rounded-full flex items-center justify-center flex-shrink-0">
                      <i className="ri-user-star-line text-lg text-accent"></i>
                    </div>
                    <div>
                      <h3 className="text-sm font-bold text-white font-serif">普洱市国家高级人才专家库</h3>
                      <p className="text-xs text-accent font-medium">专家</p>
                    </div>
                  </div>
                </div>

                <div className="bg-white/10 rounded-lg p-4 shadow-sm hover:shadow-lg transition-all duration-300">
                  <div className="flex items-center space-x-3">
                    <div className="w-10 h-10 bg-accent/20 rounded-full flex items-center justify-center flex-shrink-0">
                      <i className="ri-team-line text-lg text-accent"></i>
                    </div>
                    <div>
                      <h3 className="text-sm font-bold text-white font-serif">普洱市茶马古道研究会</h3>
                      <p className="text-xs text-accent font-medium">副会长</p>
                    </div>
                  </div>
                </div>

                <div className="bg-white/10 rounded-lg p-4 shadow-sm hover:shadow-lg transition-all duration-300">
                  <div className="flex items-center space-x-3">
                    <div className="w-10 h-10 bg-accent/20 rounded-full flex items-center justify-center flex-shrink-0">
                      <i className="ri-leaf-line text-lg text-accent"></i>
                    </div>
                    <div>
                      <h3 className="text-sm font-bold text-white font-serif">普洱茶古树女王</h3>
                      <p className="text-xs text-accent font-medium">卢云经典配方传承人</p>
                    </div>
                  </div>
                </div>
              </div>

              {/* 经典语录 */}
              <div className="bg-white/5 rounded-lg p-4 lg:p-6 border-l-4 border-accent">
                <div className="flex items-start space-x-3">
                  <i className="ri-chat-quote-line text-xl text-accent mt-1"></i>
                  <div>
                    <p className="text-base text-gray-200 leading-relaxed font-medium italic mb-3">
                      "每一片茶叶都有它的故事，每一杯茶汤都承载着三百年的传承。
                      我的使命就是让更多人品味到这份来自马帮精神的醇香。"
                    </p>
                    <p className="text-accent font-medium text-sm">— 玥姐</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BrandIP;
